<!-- layout -->
<template>
  <div class="wrap">
    <el-container>
      <!-- <el-header>
        <v-header></v-header>
      </el-header> -->
      <el-container>
        <el-main>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import VHeader from "./header";
export default {
  data() {
    return {};
  },

  components: {
    VHeader
  },

  computed: {},

  mounted() {},

  methods: {}
};
</script>
<style lang='scss' scoped>
.el-main {
  padding-top:20px;
  position: relative;
  width: 100%;
}
.el-header {
  width: 100%;
  z-index: 2000;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue